import { useMutation, useQuery, useLazyQuery } from "@apollo/client/react";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Button,
  Grid
} from
  '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useMemo, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import EmptyGridSvg from '../../../assets/svg/EmptyGridInsumo.svg';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { adaptDepositoArray } from '../../../adapters/proveedores/depositoAdapter';
import { CREATE_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/mutations/ProveedorDistribuidor/createProveedorDistribuidor';
import { UPDATE_PROVEEDOR_DISTRIBUIDOR } from '../../../data/graphQL/mutations/ProveedorDistribuidor/updateProveedorDistribuidor';
import { GET_ALL_DEPOSITO } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllDeposito';
import { EXIST_CODIGO_SAP_BY_ID_DEPOSITO } from '../../../data/graphQL/queries/ProveedorDistribuidor/existCodigoSAPByIdDeposito';
import { GET_PROVEEDORES } from '../../../data/graphQL/queries/Utils/queries';
import { getArrayObjectWithoutTypeName, getDateToString } from '../../../utils/convert';
import { BuscarProveedor } from './BuscarProveedor';
import { ModalidadModal } from './ModalidadModal';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';

import { useLocation } from 'react-router-dom';
import './proveedorDistribuidorCreationContent.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
const locale = "es-ES";
export const ProveedorDistribuidorContent = ({ setChildrenAction, setHeaderContent, setFooterContent }) => {

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalidadIsOpen, setModalidadIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;
  const editDataFormModel = stateData?.ProveedorDistribuidor;
  var isNew = Boolean(!editDataFormModel);

  const [depositos, setDepositos] = useState([]);
  const { data: dataDeposito } = useQuery(GET_ALL_DEPOSITO, {
    variables: {
      where: {
        or: [
          { regional: { eq: true } }]

      }
    }
  });

  useEffect(() => {
    if (!dataDeposito) return;
    const selectedDepositos = adaptDepositoArray(dataDeposito);
    setDepositos(selectedDepositos);
  }, [dataDeposito]);

  const initialFormModel = {
    idProveedorDistribuidor: 0,
    codigoSAP: '',
    razonSocial: '',
    contacto: '',
    telefonoAdicional: '',
    email: '',
    observacion: '',
    idDeposito: 0,
    activo: editDataFormModel.activo || false,
    modalidadBultos: [],
    modalidadKilos: [],
    modalidadKms: [],
    listModalidades: {
      bultos: [],
      kilos: [],
      kms: []
    },
    rowsModalidades: [],
    checkSelected: {
      km: false,
      peso: false,
      bulto: false
    }
  };

  const [editRow, setEditRow] = useState({});

  const [listModalidades, setListModalidades] = useState([]);

  const initialProveedor = {
    codigoProveedor: '',
    nombre: '',
    telefono: '',
    cuit: ''
  };

  const initialModalidadBulto = {
    idProveedorMetodoCobroBulto: 0,
    idProveedorDistribuidor: 0,
    cantidad: 0,
    precio: 0,
    fechaDesde: null,
    fechaHasta: null
  };

  const initialModalidadPeso = {
    idProveedorMetodoCobroKilo: 0,
    idProveedorDistribuidor: 0,
    valor: 0,
    valorExcedido: 0,
    pesoLimite: 0,
    fechaDesde: null,
    fechaHasta: null
  };

  const initialModalidadKm = {
    idProveedorMetodoCobroKM: 0,
    idProveedorDistribuidor: 0,
    valor: 0,
    fechaDesde: null,
    fechaHasta: null
  };

  const [dataFormModel, setDataFormModel] = useState(initialFormModel);
  const [dataFormProveedor, setDataFormProveedor] = useState(initialProveedor);
  const [dataModalidadBulto, setDataModalidadBulto] = useState(initialModalidadBulto);
  const [isNewModalidad, setIsNewModalidad] = useState(true);

  useEffect(() => {
    if (!isNew) {
      setDataFormModel(editDataFormModel);
      setListModalidades(editDataFormModel.rowsModalidades);
      if (!proveedoresLoading) {
        getProveedores();
      }
    }
  }, []);

  const [createProveedorDistribuidor] = useMutation(CREATE_PROVEEDOR_DISTRIBUIDOR, {
    onCompleted: () => {
      navigate('/buscarProveedorDistribuidor');
    }
  });

  const [updateProveedorDistribuidor] = useMutation(UPDATE_PROVEEDOR_DISTRIBUIDOR, {
    onCompleted: () => {
      navigate('/buscarProveedorDistribuidor');
    }
  });

  const [existCodigoSAP, { data: dataExistCodigoSAP }] = useLazyQuery(EXIST_CODIGO_SAP_BY_ID_DEPOSITO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExistCodigoSAP) return;
    return dataExistCodigoSAP;
  }, [dataExistCodigoSAP]);

  const [getProveedores, { data: proveedoresData, loading: proveedoresLoading }] = useLazyQuery(GET_PROVEEDORES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!proveedoresData) return;
    const data = proveedoresData.proveedores.valorEsperado;
    const proveedor = data?.find((x) => x.cod_Proveedor == editDataFormModel.codigoSAP);
    setDataFormProveedor({
      ...dataFormProveedor,
      cuit: proveedor?.cUIT
    });
  }, [proveedoresData]);

  const handleClickCreate = (e) => {

    if (isValidForm()) {
      createProveedorDistribuidor({
        variables: {
          codigoSAP: dataFormModel?.codigoSAP,
          razonSocial: dataFormModel?.razonSocial,
          contacto: dataFormModel?.contacto,
          telefonoAdicional: dataFormModel?.telefonoAdicional,
          observacion: dataFormModel?.observacion,
          activo: dataFormModel?.activo,
          email: dataFormModel?.email,
          idDeposito: dataFormModel?.idDeposito,
          metodoCobroBulto: dataFormModel?.modalidadBultos.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadBultos) : [],
          metodoCobroKilo: dataFormModel?.modalidadKilos.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadKilos) : [], //dataFormModel?.modalidadKilo,
          metodoCobroKM: dataFormModel?.modalidadKms.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadKms) : [] //dataFormModel?.modalidadKM
        }
      });
    }
  };

  const isValidForm = () => {

    if (dataFormModel?.codigoSAP.length <= 0) {
      toast.error('Debe seleccionar al menos un Proveedor.');
      return false;
    }

    if (dataFormModel?.idDeposito <= 0) {
      toast.error('Debe seleccionar el campo Deposito.');
      return false;
    }

    if (dataFormModel?.contacto.length <= 0) {
      toast.error('Debe seleccionar el campo Contacto.');
      return false;
    }

    return true;
  };

  const handleClickEdit = (e) => {

    if (isValidForm()) {
      updateProveedorDistribuidor({
        variables: {
          idProveedorDistribuidor: dataFormModel?.idProveedorDistribuidor,
          codigoSAP: dataFormModel?.codigoSAP,
          razonSocial: dataFormModel?.razonSocial,
          contacto: dataFormModel?.contacto,
          telefonoAdicional: dataFormModel?.telefonoAdicional,
          observacion: dataFormModel?.observacion,
          activo: dataFormModel?.activo,
          email: dataFormModel?.email,
          idDeposito: dataFormModel?.idDeposito,
          metodoCobroBulto: dataFormModel?.modalidadBultos.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadBultos) : [], //rowsPrecios,
          metodoCobroKilo: dataFormModel?.modalidadKilos.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadKilos) : [], //dataFormModel?.modalidadKilo,
          metodoCobroKM: dataFormModel?.modalidadKms.length > 0 ? getArrayObjectWithoutTypeName(dataFormModel?.modalidadKms) : [] //dataFormModel?.modalidadKM
        }
      });
    }

  };

  useEffect(() => {
    setChildrenAction(() =>
      <CustomButton
        variant='contained'
        onClick={isNew ? handleClickCreate : handleClickEdit}
        disableElevation
        size='small'>

        {isNew ? 'Crear' : 'Editar'}
      </CustomButton>
    );

  }, [setChildrenAction, setHeaderContent, setFooterContent, dataFormModel, dataFormProveedor]);

  const handleChange = (e) => {
    const { value, name } = e.target;

    setDataFormModel((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const handleToggle = (e) => {
    const { checked, name } = e.target;
    setDataFormModel((previousData) => ({
      ...previousData,
      [name]: checked
    }));
  };

  const handleChangeDeposito = async (e) => {
    const { value } = e.target;

    if (dataFormModel?.codigoSAP.length <= 0) {
      toast.error('Debe seleccionar al menos un Proveedor para seleccionar un deposito.');
      return false;
    }

    const { data: validateCodSap } = await existCodigoSAP({
      variables: {
        idDeposito: value,
        codigoSAP: dataFormModel?.codigoSAP
      }
    });

    // Valido si existe codigo sap
    if (validateCodSap.existCodigoSAPByIdDeposito) {
      setDataFormModel((previousData) => ({
        ...previousData,
        idDeposito: 0
      }));
      toast.error("Ya existe el Proveedor para ese Deposito.");
      return false;
    } else {
      setDataFormModel((previousData) => ({
        ...previousData,
        idDeposito: value
      }));
    }
  };

  const handleSearchProveedores = () => {
    setModalIsOpen(true);
  };

  const handleRowClickProveedor = (params) => {
    const { row } = params;
    setModalIsOpen(false);

    setDataFormModel({
      ...dataFormModel,
      codigoSAP: row.cod_Proveedor,
      razonSocial: row.nombre
    });

    setDataFormProveedor({
      ...dataFormProveedor,
      telefono: row.telefono,
      cuit: row.cUIT
    });

  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => handleEditModalidad(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div onClick={() => handleDeleteModalidad(row)} aria-hidden='true'
                  className='item-option'>

                  <DeleteIcon className='edit-icon' />
                  <span className='toggle-action'>Eliminar</span>
                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'modalidad',
      headerName: 'Modalidad'
    },
    {
      field: 'fechaDesde',
      headerName: 'Fecha Desde',
      valueGetter: (fechaDesde) => {
        return getDateToString(fechaDesde);
      }
    },
    {
      field: 'fechaHasta',
      headerName: 'Fecha Hasta',
      valueGetter: (fechaHasta) => {
        return getDateToString(fechaHasta);
      }
    },
    {
      field: 'cantidad',
      headerName: 'Cantidad'
    },
    {
      field: 'pesoExcedido',
      headerName: 'Peso Excedido',
      valueGetter: (pesoExcedido) => pesoExcedido ? '$' + pesoExcedido : '' + pesoExcedido
    },
    {
      field: 'pesoLimite',
      headerName: 'Peso Límite',
      valueGetter: (pesoLimite) => pesoLimite ? pesoLimite + 'Kg' : pesoLimite
    },
    {
      field: 'valor',
      headerName: 'Valor',
      valueGetter: (valor) => '$' + valor
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleAddModalidad = () => {
    setIsNewModalidad(true);
    setModalidadIsOpen(true);
    setEditRow({});
  };

  const handleEditModalidad = (row) => {
    setIsNewModalidad(false);
    setModalidadIsOpen(true);
    setEditRow(row);
  };

  const handleDeleteModalidad = (row) => {
    switch (row.modalidad) {
      case 'Km': {
        const idProveedorMetodoCobroKM = row.id > 0 ? row.id - 3000 : row.id;
        setDataFormModel((previousData) => ({
          ...previousData,
          modalidadKms: [...previousData.modalidadKms.filter((x) => x.idProveedorMetodoCobroKM !== idProveedorMetodoCobroKM)],
          rowsModalidades: [...previousData.rowsModalidades.filter((x) => x.id !== row.id)]
        }));
        break;
      }
      case 'Kilo': {
        const idProveedorMetodoCobroKilo = row.id > 0 ? row.id - 2000 : row.id;
        setDataFormModel((previousData) => ({
          ...previousData,
          modalidadKilos: [...previousData.modalidadKilos.filter((x) => x.idProveedorMetodoCobroKilo !== idProveedorMetodoCobroKilo)],
          rowsModalidades: [...previousData.rowsModalidades.filter((x) => x.id !== row.id)]
        }));
        break;
      }
      case 'Bulto': {
        const idProveedorMetodoCobroBulto = row.id > 0 ? row.id - 1000 : row.id;
        setDataFormModel((previousData) => ({
          ...previousData,
          modalidadBultos: [...previousData.modalidadBultos.filter((x) => x.idProveedorMetodoCobroBulto !== idProveedorMetodoCobroBulto)],
          rowsModalidades: [...previousData.rowsModalidades.filter((x) => x.id !== row.id)]
        }));
        break;
      }
    }
  };

  return (
    <>
      <div className='proveedor-distribuidor-creation-content'>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginBottom={2}
          spacing={1.5}>

          <Grid size={{ xs: 1.2 }}>
            <TextInput
              label='Buscador'
              searchIcon
              placeholder='Buscador'
              name='codigoSAP'
              onClick={isNew ? handleSearchProveedores : () => { }}
              value={dataFormModel?.codigoSAP}
              disabled={!isNew} />

          </Grid>
          <Grid size={{ xs: 2 }}>
            <TextInput
              label='Razon Social'
              placeholder='Razon Social'
              name='razonSocial'
              value={dataFormModel?.razonSocial}
              disabled />

          </Grid>
          <Grid size={{ xs: 1.5 }}>
            <SelectInput
              options={depositos}
              label='Deposito'
              onChange={handleChangeDeposito}
              value={dataFormModel?.idDeposito}
              name='idDeposito' />

          </Grid>
          <Grid size={{ xs: 1.2 }}>
            <TextInput
              label='Telefono'
              placeholder='Telefono'
              value={dataFormProveedor?.telefono}
              disabled />

          </Grid>
          <Grid size={{ xs: 1.2 }}>
            <TextInput
              label='CUIT'
              placeholder='CUIT'
              value={dataFormProveedor?.cuit}
              disabled />

          </Grid>
          <Grid size={{ xs: 0.8 }}>
            <div className='switch-row'>
              <span className='span-row'>Activo</span>
              <SwitchInput
                onChange={handleToggle}
                name='activo'
                checked={dataFormModel?.activo}
                className='switch-row container' />

            </div>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginBottom={2}
          spacing={1.5}>

          <Grid size={{ xs: 2.6 }}>
            <TextInput
              label='Contacto'
              placeholder='Contacto'
              name='contacto'
              value={dataFormModel?.contacto}
              onChange={handleChange} />

          </Grid>
          <Grid size={{ xs: 2.6 }}>
            <TextInput
              label='Telefono Adicional'
              placeholder='Telefono Adicional'
              name='telefonoAdicional'
              value={dataFormModel?.telefonoAdicional}
              onChange={handleChange} />

          </Grid>
          <Grid size={{ xs: 2.6 }}>
            <TextInput
              label='E-mail'
              placeholder='E-mail'
              name='email'
              value={dataFormModel?.email}
              onChange={handleChange} />

          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          spacing={1.5}>

          <Grid size={{ xs: 12 }}>
            <TextInput
              label='Observaciones'
              placeholder='Observaciones'
              name='observacion'
              multiline
              rows={4}
              value={dataFormModel?.observacion}
              onChange={handleChange} />

          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          marginTop={2}
          className='grid-modalidad'>

          <Grid size={{ xs: 8 }}>

            {
              dataFormModel?.rowsModalidades?.length == 0 &&
              <div className='empty-grid'>
                <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
                <p>No se ha agregado ninguna modalidad</p>
                <CustomButton
                  variant='contained'
                  onClick={handleAddModalidad}
                  disableElevation
                  size='small'>

                  Agregar
                </CustomButton>
              </div>
            }
            {dataFormModel?.rowsModalidades?.length > 0 &&
              <>
                <div className='custom-button'>
                  <CustomButton
                    variant='contained'
                    onClick={handleAddModalidad}
                    disableElevation
                    size='small'>

                    Agregar
                  </CustomButton>
                </div>

                <DataGridGenerico
                  className='data-grid'
                  columns={columns}
                  rows={dataFormModel.rowsModalidades}
                  toolbar={false} />

              </>
            }
          </Grid>
        </Grid>

      </div>

      <ModalidadModal
        open={modalidadIsOpen}
        onClose={() => setModalidadIsOpen(false)}
        dataFormModel={dataFormModel}
        setDataFormModel={setDataFormModel}
        isNew={isNewModalidad}
        editRow={editRow} />


      <BuscarProveedor
        open={modalIsOpen}
        onRowClick={handleRowClickProveedor}
        onClose={() => setModalIsOpen(false)} />

    </>);

};